module.exports = __webpack_public_path__ + "static/media/sponsor-Jennifer.a0394d87.jpg";